import React from 'react';
import { useCloneMentorshipProgram } from '../state/context';
import CloneSourceProgramInfo from './clone-source-program-info';
import CloneMentorshipProgramForm from './clone-mentorship-program-form';

const CloneMentorshipProgramStepOne = () => {
  const { state } = useCloneMentorshipProgram();
  const adminsCount = state.admins.length > 0
    ? state.admins.length
    : state.sourceProgram?.adminsCount || 0;

  return (
    <div>
      <CloneSourceProgramInfo
        sourceProgram={state.sourceProgram}
        programDataOverride={{ adminsCount }}
      />
      <CloneMentorshipProgramForm />
    </div>
  );
};

export default CloneMentorshipProgramStepOne;
